export default class kinoTooltip {
    constructor(id, text, options){
        this.id = id;
        this.text = text;
        this.options = options
        this.tooltipTimeout;
        this.timeoutFunc=0;
        this.closeIcon=`<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;
    };


    addTooltip(){
        let t = this;
        t.tooltipText=$("<p/>",{
            class:"tooltip-inside-text",
            html: this.text
        });

        t.toolTipCloseBtn=$("<div/>",{
            class:"tooltip-exit-btn",
            html: this.closeIcon
        }).on('click',(e)=>{
            e.stopPropagation();
            e.preventDefault();
            if(this.timeoutFunc){
                clearTimeout(this.timeoutFunc);
            }
            localStorage.setItem(this.id,1);
            t.hideTooltip();
        });

        t.tooltip=$("<div/>",{
            class:`kino-tooltip-container align-right ${this.options.customClass ? this.options.customClass : ''}`,
            style:`${this.options.width?'width:'+this.options.width+';'+'max-width:'+this.options.width+';':''}`,
            html:[t.tooltipText,t.toolTipCloseBtn]
        });

        t.tooltip.appendTo($('#'+this.id));

        t.tooltip.css("display","flex");
        t.tooltip.animate({opacity:1},100);
        Object.keys(this.options).forEach(key => {
            // console.log(key, this.options[key])
            t.tooltip.css(key, this.options[key])
          });
        this.timeoutFunc = setTimeout(() => {
            t.hideTooltip();
        }, this.options.autohideSeconds ? this.options.autohideSeconds * 1000 : 5000);

    };

    showTooltip(data){
        // console.log(data)
        // console.error(data.container[0])
        let t = this;
        let message = data.message;
        let container = data.container[0];
        let options = data.options;

        //clear the tooltips before showing the next one
        if($(t.kinoTooltipContainer)){
            $(t.kinoTooltipContainer).remove();
        }

        let tooltipText=$("<p/>",{
            class:"tooltip-inside-text",
            html: message
        });

        let toolTipCloseBtn=$("<div/>",{
            class:"tooltip-exit-btn",
            html: this.closeIcon
        }).on('click',function(){
            t.removeTooltip();
        });

        t.kinoTooltipContainer=$("<div/>",{
            class:`kino-tooltip-container align-right`,
            html:[tooltipText, toolTipCloseBtn]
        });

        // tooltip.appendTo('.timer-timers-container');
        $(container).append(t.kinoTooltipContainer)

        t.kinoTooltipContainer.css("display","flex");
        t.kinoTooltipContainer.animate({opacity:1},100);
        Object.keys(options).forEach(key => {
            // console.log(key, options[key])
            t.kinoTooltipContainer.css(key, options[key])
        });
        if(t.tooltipTimeout){
            clearTimeout(t.tooltipTimeout);
        }
        t.tooltipTimeout = setTimeout(() => {
            t.removeTooltip();
        }, 5000);
    }

    removeTooltip(){
        let t = this;
        if(t.tooltipTimeout){
            clearTimeout(t.tooltipTimeout);
        }
        if($(t.kinoTooltipContainer)){
            $(t.kinoTooltipContainer).remove();
        }
    }
    destroy(){
        try {
            clearTimeout(this.timeoutFunc);
            if(this.tooltip){
                this.tooltip.remove(); 
            }
        } catch (error) { console.error("[Kino Error] [kinoTooltip]", error); }
    }
    hideTooltip(){
        // let tooltip = $(`#${this.id}`).find('.kino-tooltip-container');
        try {

            this.tooltip.css('opacity', '0');
            setTimeout(() =>{
                this.tooltip.remove();
            }, 500)
        } catch (error) {
            console.log("Tooltip error",error);
            // this.tooltip.remove()
        }
    };

    lobbyViewEvent(data){
        let t = this;
        try{
            if(data.usersOnLobby <= 1 ){

            }
        }catch(error){
            console.error("Lobby view event error: ", error);
        }
    };

    canShowTooltip(){
        let t = this;
        // if(Video.mainParticipants[id]==undefined){return false}
        if(localStorage.getItem(this.id)){return false}
        return true;
    };
};
